import { t } from "@/utils";
import { ElMessageBox, ElMessage, ElLoading } from "element-plus";
import api from "@/api/config/conversation";
// 关闭会话
export const useCloseConversation = async (conversationId) => {
  try {
    await ElMessageBox.confirm(
      t("conversation.serviceList.closeSession"),
      t("action.tips"),
      {
        confirmButtonText: t("action.confirmBtn"),
        cancelButtonText: t("action.cancel"),
        type: "warning",
      }
    );
    const { data } = await api.closeConversation({ conversationId });
    if (data.code !== 0) return;
    ElMessage.success(t("conversation.serviceList.closeSuccess"));
  } catch (err) {
    console.log(err);
  }
};
// 消息未读
export const useUnreadMessage = async (conversationId) => {
  try {
    await ElMessageBox.confirm(
      t("conversation.serviceList.unReadMessage"),
      t("action.tips"),
      {
        confirmButtonText: t("action.confirmBtn"),
        cancelButtonText: t("action.cancel"),
        type: "warning",
      }
    );
    const { data } = await api.unreadMessage({ conversationId });
    if (data.code !== 0) return;
    ElMessage.success(t("action.success"));
  } catch (err) {
    console.log(err);
  }
};
// 分配客服- conversationId-会话id，assignId-客服id
export const useAssignAgent = async (
  conversationId,
  assignId,
  conversationIds
) => {
  const { data } = await api.conversationAssign({
    assignId,
    conversationId,
    conversationIds,
  });
  if (data.code !== 0) return;
  ElMessage.success(t("conversation.serviceList.allocationSuccess"));
};

// 全局loading加载
export const useLoading = () => {
  const loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  return loading;
};
